











import { Component, Inject, Vue } from "vue-property-decorator";
import { ICProdProvider } from "@/models/providers/contractProduct";
import TimelineTable from "@/components/app/global/timelineComponent/timelineTable.vue";

@Component({
  components: {
    TimelineTable
  }
})
export default class ContractProductActivityLog extends Vue {
  // Inject
  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;
  // Computed
  public get cProdData() {
    return this.$cProdData();
  }
}
